module.exports = __webpack_public_path__ + "img/jizu.767f8b44.png";